module.exports = __webpack_public_path__ + "img/LandingTrackingDetails.0bb14283.webp";